import { ConfirmationModal } from "src/base-components/ConfirmationModal";
import { pluralizeWord } from "src/utils/stringUtils";

type Props = {
  isOpen: boolean;
  caseCount: number;
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
};

export const ArchiveCasesConfirmModal: React.FC<Props> = ({
  isOpen,
  caseCount,
  onConfirm,
  onClose,
}) => {
  const caseWord = pluralizeWord(caseCount, "case");

  return (
    <ConfirmationModal
      cancelationButtonText="Cancel"
      confirmationButtonText={`Archive ${caseWord}`}
      dataLoc="archive-cases-confirm-modal"
      description={`${caseCount === 1 ? "This case" : "These cases"} will be removed from the queue and will not be visible anymore. This action cannot be undone.`}
      open={isOpen}
      title={`Archive ${caseCount} live ${caseWord}?`}
      variant="danger"
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
